module.exports = __webpack_public_path__ + "img/65.6299d622.jpg";